import { ROUTES } from '../constants/routes';
import {
  ACCOUNT_MENU_DEFS,
  MAIN_MENU_DEFS,
  SUPER_ADMIN_MORE_MENU_DEFS,
  SUPER_ADMIN_PRIMARY_MENU_DEFS,
  TENANT_MORE_MENU_DEFS,
  TENANT_PRIMARY_MENU_DEFS,
} from './panelMenuDefs';

const STATIC_LABELS = {
  [ROUTES.DASHBOARD]: 'داشبورد',
  [ROUTES.MEETINGS]: 'جلسات',
  [ROUTES.MEETINGS_NEW]: 'جلسه جدید',
  [ROUTES.MEETING_GROUPS]: 'کارگروه‌ها',
  [ROUTES.ROOMS]: 'اتاق‌ها',
  [ROUTES.ROOMS_NEW]: 'اتاق جدید',
  [ROUTES.ANNOUNCEMENTS]: 'اطلاعیه‌ها',
  [ROUTES.NOTIFICATIONS]: 'اعلان‌ها',
  [ROUTES.USERS]: 'کاربران',
  [ROUTES.USERS_NEW]: 'کاربر جدید',
  [ROUTES.ORGANIZATIONS]: 'سازمان‌ها',
  [ROUTES.ORGANIZATIONS_NEW]: 'سازمان جدید',
  [ROUTES.ORG_MEMBERS]: 'اعضا',
  [ROUTES.ORG_ROLES]: 'نقش‌ها و دسترسی‌ها',
  [ROUTES.WORKSPACE]: 'سازمان من',
  [ROUTES.FILES]: 'فایل‌ها',
  [ROUTES.ACTION_ITEMS]: 'اقدام‌ها',
  [ROUTES.ACTION_ITEMS_NEW]: 'اقدام جدید',
  [ROUTES.MINUTES]: 'صورت جلسات',
  [ROUTES.MINUTES_NEW]: 'صورت‌جلسه جدید',
  [ROUTES.STT_JOBS]: 'تبدیل گفتار',
  [ROUTES.TRANSCRIPTS]: 'رونوشت‌ها',
  [ROUTES.CALENDAR]: 'تقویم',
  [ROUTES.REPORTS]: 'گزارش‌ها',
  [ROUTES.SEARCH]: 'جستجو',
  [ROUTES.PROFILE]: 'پروفایل',
  [ROUTES.SECURITY]: 'امنیت حساب',
  [ROUTES.PERSONAL_WORKSPACE_NEW]: 'فضای کاری شخصی',
  [ROUTES.SETTINGS]: 'تنظیمات',
  [ROUTES.BILLING]: 'مالی و پرداخت',
  [ROUTES.BILLING_CALLBACK]: 'نتیجه پرداخت',
  [ROUTES.ROLES_AND_PERMISSIONS]: 'نقش‌ها و دسترسی‌ها',
  [ROUTES.WEBHOOK_DEAD_LETTERS]: 'صف وب‌هوک',
  [ROUTES.AUDIT_EVENTS]: 'تاریخچه فعالیت‌ها',
  [ROUTES.AGENDA_TEMPLATES]: 'قالب دستور جلسه',
  [ROUTES.AGENDA_TEMPLATES_NEW]: 'قالب جدید',
  [ROUTES.AGENDA_TEMPLATES_MARKETPLACE]: 'بازارچه قالب',
};

function collectMenuLabels() {
  const map = { ...STATIC_LABELS };
  [
    ...MAIN_MENU_DEFS,
    ...SUPER_ADMIN_PRIMARY_MENU_DEFS,
    ...SUPER_ADMIN_MORE_MENU_DEFS,
    ...TENANT_PRIMARY_MENU_DEFS,
    ...TENANT_MORE_MENU_DEFS,
    ...ACCOUNT_MENU_DEFS,
  ].forEach((item) => {
    if (item?.key && item?.label) map[item.key] = item.label;
  });
  return map;
}

export const BREADCRUMB_LABELS = collectMenuLabels();

const BILLING_SECTION_LABELS = {
  subscription: 'وضعیت اشتراک',
  purchase: 'خرید و ارتقا',
  usage: 'مصرف و ظرفیت‌ها',
  invoices: 'فاکتورها',
  payments: 'پرداخت‌ها',
  profile: 'اطلاعات مالی',
  audit: 'تاریخچه تغییرات',
  wallet: 'اعتبار سازمان',
  overview: 'اعتبار سازمان',
  charge: 'افزایش اعتبار',
  history: 'گردش حساب',
  package: 'وضعیت اشتراک',
  'commerce-overview': 'وضعیت اشتراک',
  'commerce-history': 'تاریخچه تغییرات',
  'commerce-catalog': 'خرید و ارتقا',
  'platform-revenue': 'داشبورد',
  'platform-pricing-models': 'پلن‌ها',
  'platform-commerce-catalog': 'پلن‌ها',
  'platform-resources': 'افزونه‌ها',
  'platform-addons': 'افزونه‌ها',
  'platform-subscriptions': 'همه اشتراک‌ها',
  'platform-renewals': 'تمدید نزدیک',
  'platform-upgrades': 'همه اشتراک‌ها',
  'platform-orders-quotes': 'سفارش‌ها',
  'platform-proposals': 'پلن سفارشی',
  'platform-sales-requests': 'درخواست مشاوره',
  'platform-invoices': 'سفارش‌ها',
  'platform-payments': 'سفارش‌ها',
  'platform-discounts': 'تخفیف، مالیات و درگاه',
  'platform-reports': 'گزارش درآمد',
  'platform-plan-performance': 'گزارش عملکرد پلن‌ها',
  'platform-ai-economics': 'سود هوش مصنوعی',
  'platform-orgs': 'اعتبار سازمان‌ها',
  'platform-catalog': 'محصولات و نسخه‌ها',
  'platform-operations': 'عملیات سازمان‌ها',
};

const SETTINGS_SECTION_LABELS = {
  brand: 'برند',
  notifications: 'اعلان‌ها',
  sms: 'پیامک',
  fx: 'نرخ ارز',
  'ai-hub': 'هوش مصنوعی',
  general: 'عمومی',
};

const MEETING_TAB_LABELS = {
  overview: 'نمای کلی',
  attendees: 'حاضران',
  agenda: 'دستور جلسه',
  minutes: 'صورت‌جلسه',
  recordings: 'ضبط‌ها',
  stt: 'تبدیل گفتار',
  analysis: 'تحلیل',
  'ai-requests': 'مصرف هوش مصنوعی',
};

const ORG_TAB_LABELS = {
  overview: 'نمای کلی',
  members: 'اعضا',
  departments: 'دپارتمان‌ها',
  invitations: 'دعوت‌ها',
  package: 'بسته',
  finance: 'مالی',
  roles: 'نقش‌ها',
  credit: 'اعتبار',
};

/**
 * الگوهای مسیر تو در تو — از خاص به عام مرتب شوند.
 * titleKey برای خواندن عنوان پویا از context استفاده می‌شود.
 */
export const BREADCRUMB_ROUTE_PATTERNS = [
  {
    test: /^\/meetings\/([^/]+)\/recordings\/([^/]+)\/assets\/?$/,
    crumbs: (m, titles) => [
      { path: ROUTES.MEETINGS, label: BREADCRUMB_LABELS[ROUTES.MEETINGS] },
      { path: `/meetings/${m[1]}`, label: titles[`meeting:${m[1]}`] || 'جزئیات جلسه' },
      { path: null, label: 'فایل‌های ضبط' },
    ],
  },
  {
    test: /^\/meetings\/([^/]+)\/recordings\/([^/]+)\/events\/?$/,
    crumbs: (m, titles) => [
      { path: ROUTES.MEETINGS, label: BREADCRUMB_LABELS[ROUTES.MEETINGS] },
      { path: `/meetings/${m[1]}`, label: titles[`meeting:${m[1]}`] || 'جزئیات جلسه' },
      { path: null, label: 'رخدادهای ضبط' },
    ],
  },
  {
    test: /^\/meetings\/([^/]+)\/edit\/?$/,
    crumbs: (m, titles) => [
      { path: ROUTES.MEETINGS, label: BREADCRUMB_LABELS[ROUTES.MEETINGS] },
      { path: `/meetings/${m[1]}`, label: titles[`meeting:${m[1]}`] || 'جزئیات جلسه' },
      { path: null, label: 'ویرایش' },
    ],
  },
  {
    test: /^\/meetings\/new\/?$/,
    crumbs: () => [
      { path: ROUTES.MEETINGS, label: BREADCRUMB_LABELS[ROUTES.MEETINGS] },
      { path: null, label: 'جلسه جدید' },
    ],
  },
  {
    test: /^\/meetings\/([^/]+)\/?$/,
    crumbs: (m, titles, search) => {
      const tab = search.get('tab');
      const base = [
        { path: ROUTES.MEETINGS, label: BREADCRUMB_LABELS[ROUTES.MEETINGS] },
        {
          path: tab ? `/meetings/${m[1]}` : null,
          label: titles[`meeting:${m[1]}`] || 'جزئیات جلسه',
        },
      ];
      if (tab && MEETING_TAB_LABELS[tab]) {
        base.push({ path: null, label: MEETING_TAB_LABELS[tab] });
      }
      return base;
    },
  },
  {
    test: /^\/meeting-collections\/([^/]+)\/?$/,
    crumbs: (m, titles) => [{ path: '/meeting-groups', label: 'کارگروه‌ها' }, { path: null, label: titles[`meeting-collection:${m[1]}`] || 'مجموعه جلسات' }],
  },
  {
    test: /^\/meeting-groups\/([^/]+)\/?$/,
    crumbs: (m, titles) => [
      { path: ROUTES.MEETING_GROUPS, label: BREADCRUMB_LABELS[ROUTES.MEETING_GROUPS] },
      { path: null, label: titles[`meeting-group:${m[1]}`] || 'جزئیات کارگروه' },
    ],
  },
  {
    test: /^\/rooms\/([^/]+)\/edit\/?$/,
    crumbs: (m, titles) => [
      { path: ROUTES.ROOMS, label: BREADCRUMB_LABELS[ROUTES.ROOMS] },
      { path: `/rooms/${m[1]}`, label: titles[`room:${m[1]}`] || 'جزئیات اتاق' },
      { path: null, label: 'ویرایش' },
    ],
  },
  {
    test: /^\/rooms\/new\/?$/,
    crumbs: () => [
      { path: ROUTES.ROOMS, label: BREADCRUMB_LABELS[ROUTES.ROOMS] },
      { path: null, label: 'اتاق جدید' },
    ],
  },
  {
    test: /^\/rooms\/([^/]+)\/?$/,
    crumbs: (m, titles, search) => {
      const tab = search.get('tab');
      const base = [
        { path: ROUTES.ROOMS, label: BREADCRUMB_LABELS[ROUTES.ROOMS] },
        { path: tab ? `/rooms/${m[1]}` : null, label: titles[`room:${m[1]}`] || 'جزئیات اتاق' },
      ];
      if (tab) base.push({ path: null, label: tab === 'meetings' ? 'جلسات' : tab === 'booking' ? 'رزرو' : 'نمای کلی' });
      return base;
    },
  },
  {
    test: /^\/organizations\/([^/]+)\/departments\/([^/]+)\/members\/?$/,
    crumbs: (m, titles) => [
      { path: ROUTES.ORGANIZATIONS, label: BREADCRUMB_LABELS[ROUTES.ORGANIZATIONS] },
      { path: `/organizations/${m[1]}`, label: titles[`organization:${m[1]}`] || 'جزئیات سازمان' },
      { path: null, label: titles[`department:${m[2]}`] || 'اعضای دپارتمان' },
    ],
  },
  {
    test: /^\/organizations\/([^/]+)\/edit\/?$/,
    crumbs: (m, titles) => [
      { path: ROUTES.ORGANIZATIONS, label: BREADCRUMB_LABELS[ROUTES.ORGANIZATIONS] },
      { path: `/organizations/${m[1]}`, label: titles[`organization:${m[1]}`] || 'جزئیات سازمان' },
      { path: null, label: 'ویرایش' },
    ],
  },
  {
    test: /^\/organizations\/new\/?$/,
    crumbs: () => [
      { path: ROUTES.ORGANIZATIONS, label: BREADCRUMB_LABELS[ROUTES.ORGANIZATIONS] },
      { path: null, label: 'سازمان جدید' },
    ],
  },
  {
    test: /^\/organizations\/([^/]+)\/?$/,
    crumbs: (m, titles, search) => {
      const tab = search.get('tab');
      const base = [
        { path: ROUTES.ORGANIZATIONS, label: BREADCRUMB_LABELS[ROUTES.ORGANIZATIONS] },
        {
          path: tab ? `/organizations/${m[1]}` : null,
          label: titles[`organization:${m[1]}`] || 'جزئیات سازمان',
        },
      ];
      if (tab && ORG_TAB_LABELS[tab]) base.push({ path: null, label: ORG_TAB_LABELS[tab] });
      return base;
    },
  },
  {
    test: /^\/users\/([^/]+)\/edit\/?$/,
    crumbs: (m, titles) => [
      { path: ROUTES.USERS, label: BREADCRUMB_LABELS[ROUTES.USERS] },
      { path: `/users/${m[1]}`, label: titles[`user:${m[1]}`] || 'جزئیات کاربر' },
      { path: null, label: 'ویرایش' },
    ],
  },
  {
    test: /^\/users\/new\/?$/,
    crumbs: () => [
      { path: ROUTES.USERS, label: BREADCRUMB_LABELS[ROUTES.USERS] },
      { path: null, label: 'کاربر جدید' },
    ],
  },
  {
    test: /^\/users\/([^/]+)\/?$/,
    crumbs: (m, titles) => [
      { path: ROUTES.USERS, label: BREADCRUMB_LABELS[ROUTES.USERS] },
      { path: null, label: titles[`user:${m[1]}`] || 'جزئیات کاربر' },
    ],
  },
  {
    test: /^\/files\/([^/]+)\/?$/,
    crumbs: (m, titles) => [
      { path: ROUTES.FILES, label: BREADCRUMB_LABELS[ROUTES.FILES] },
      { path: null, label: titles[`file:${m[1]}`] || 'جزئیات فایل' },
    ],
  },
  {
    test: /^\/action-items\/([^/]+)\/print\/?$/,
    crumbs: (m, titles) => [
      { path: ROUTES.ACTION_ITEMS, label: BREADCRUMB_LABELS[ROUTES.ACTION_ITEMS] },
      { path: `/action-items/${m[1]}`, label: titles[`action-item:${m[1]}`] || 'جزئیات اقدام' },
      { path: null, label: 'چاپ' },
    ],
  },
  {
    test: /^\/action-items\/([^/]+)\/edit\/?$/,
    crumbs: (m, titles) => [
      { path: ROUTES.ACTION_ITEMS, label: BREADCRUMB_LABELS[ROUTES.ACTION_ITEMS] },
      { path: `/action-items/${m[1]}`, label: titles[`action-item:${m[1]}`] || 'جزئیات اقدام' },
      { path: null, label: 'ویرایش' },
    ],
  },
  {
    test: /^\/action-items\/new\/?$/,
    crumbs: () => [
      { path: ROUTES.ACTION_ITEMS, label: BREADCRUMB_LABELS[ROUTES.ACTION_ITEMS] },
      { path: null, label: 'اقدام جدید' },
    ],
  },
  {
    test: /^\/action-items\/([^/]+)\/?$/,
    crumbs: (m, titles) => [
      { path: ROUTES.ACTION_ITEMS, label: BREADCRUMB_LABELS[ROUTES.ACTION_ITEMS] },
      { path: null, label: titles[`action-item:${m[1]}`] || 'جزئیات اقدام' },
    ],
  },
  {
    test: /^\/minutes\/new\/?$/,
    crumbs: () => [
      { path: ROUTES.MINUTES, label: BREADCRUMB_LABELS[ROUTES.MINUTES] },
      { path: null, label: 'صورت‌جلسه جدید' },
    ],
  },
  {
    test: /^\/minutes\/([^/]+)\/?$/,
    crumbs: (m, titles) => [
      { path: ROUTES.MINUTES, label: BREADCRUMB_LABELS[ROUTES.MINUTES] },
      { path: null, label: titles[`minute:${m[1]}`] || 'جزئیات صورت‌جلسه' },
    ],
  },
  {
    test: /^\/stt\/jobs\/([^/]+)\/?$/,
    crumbs: (m, titles) => [
      { path: ROUTES.STT_JOBS, label: BREADCRUMB_LABELS[ROUTES.STT_JOBS] },
      { path: null, label: titles[`stt-job:${m[1]}`] || 'جزئیات تبدیل' },
    ],
  },
  {
    test: /^\/transcripts\/([^/]+)\/?$/,
    crumbs: (m, titles) => [
      { path: ROUTES.TRANSCRIPTS, label: BREADCRUMB_LABELS[ROUTES.TRANSCRIPTS] },
      { path: null, label: titles[`transcript:${m[1]}`] || 'جزئیات رونوشت' },
    ],
  },
  {
    test: /^\/agenda-templates\/([^/]+)\/edit\/?$/,
    crumbs: (m, titles) => [
      { path: ROUTES.AGENDA_TEMPLATES, label: BREADCRUMB_LABELS[ROUTES.AGENDA_TEMPLATES] },
      { path: `/agenda-templates/${m[1]}`, label: titles[`agenda-template:${m[1]}`] || 'جزئیات قالب' },
      { path: null, label: 'ویرایش' },
    ],
  },
  {
    test: /^\/agenda-templates\/([^/]+)\/?$/,
    crumbs: (m, titles) => [
      { path: ROUTES.AGENDA_TEMPLATES, label: BREADCRUMB_LABELS[ROUTES.AGENDA_TEMPLATES] },
      { path: null, label: titles[`agenda-template:${m[1]}`] || 'جزئیات قالب' },
    ],
  },
  {
    test: /^\/agendas\/([^/]+)\/?$/,
    crumbs: (m, titles) => [
      { path: ROUTES.MEETINGS, label: BREADCRUMB_LABELS[ROUTES.MEETINGS] },
      { path: null, label: titles[`agenda:${m[1]}`] || 'دستور جلسه' },
    ],
  },
  {
    test: /^\/billing\/?$/,
    crumbs: (_m, _titles, search) => {
      const section = search.get('section');
      const base = [{ path: section ? ROUTES.BILLING : null, label: BREADCRUMB_LABELS[ROUTES.BILLING] }];
      if (section && BILLING_SECTION_LABELS[section]) {
        base[0].path = ROUTES.BILLING;
        base.push({ path: null, label: BILLING_SECTION_LABELS[section] });
      }
      return base;
    },
  },
  {
    test: /^\/settings\/?$/,
    crumbs: (_m, _titles, search) => {
      const section = search.get('section');
      const base = [{ path: section ? ROUTES.SETTINGS : null, label: BREADCRUMB_LABELS[ROUTES.SETTINGS] }];
      if (section && SETTINGS_SECTION_LABELS[section]) {
        base[0].path = ROUTES.SETTINGS;
        base.push({ path: null, label: SETTINGS_SECTION_LABELS[section] });
      }
      return base;
    },
  },
];

export function resolveBreadcrumbs(pathname, searchParams, titles = {}) {
  const path = pathname.replace(/\/+$/, '') || '/';
  if (path === ROUTES.DASHBOARD || path === ROUTES.ROOT || path === '') {
    return [{ path: null, label: BREADCRUMB_LABELS[ROUTES.DASHBOARD] }];
  }

  for (const pattern of BREADCRUMB_ROUTE_PATTERNS) {
    const match = path.match(pattern.test);
    if (match) {
      return [
        { path: ROUTES.DASHBOARD, label: BREADCRUMB_LABELS[ROUTES.DASHBOARD] },
        ...pattern.crumbs(match, titles, searchParams),
      ];
    }
  }

  const staticLabel = BREADCRUMB_LABELS[path];
  if (staticLabel) {
    return [
      { path: ROUTES.DASHBOARD, label: BREADCRUMB_LABELS[ROUTES.DASHBOARD] },
      { path: null, label: staticLabel },
    ];
  }

  return [
    { path: ROUTES.DASHBOARD, label: BREADCRUMB_LABELS[ROUTES.DASHBOARD] },
    { path: null, label: 'صفحه جاری' },
  ];
}
